import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const primaryColorLightMode : string =  getComputedStyle(document.documentElement).getPropertyValue('--color-brand-600').trim();
const primaryColorDarkMode : string =  getComputedStyle(document.documentElement).getPropertyValue('--color-brand-400').trim();


const colorBrand900 : string =  getComputedStyle(document.documentElement).getPropertyValue('--color-brand-900').trim();
const colorBrand800 : string =  getComputedStyle(document.documentElement).getPropertyValue('--color-brand-800').trim();
const colorBrand700 : string =  getComputedStyle(document.documentElement).getPropertyValue('--color-brand-700').trim();
const colorBrand612 : string =  getComputedStyle(document.documentElement).getPropertyValue('--color-brand-612').trim();
const colorBrand608 : string =  getComputedStyle(document.documentElement).getPropertyValue('--color-brand-608').trim();
const colorBrand602 : string =  getComputedStyle(document.documentElement).getPropertyValue('--color-brand-602').trim();
const colorBrand600 : string =  getComputedStyle(document.documentElement).getPropertyValue('--color-brand-600').trim();
const colorBrand500 : string =  getComputedStyle(document.documentElement).getPropertyValue('--color-brand-500').trim();
const colorBrand400 : string =  getComputedStyle(document.documentElement).getPropertyValue('--color-brand-400').trim();
const colorBrand300 : string =  getComputedStyle(document.documentElement).getPropertyValue('--color-brand-300').trim();
const colorBrand200 : string =  getComputedStyle(document.documentElement).getPropertyValue('--color-brand-200').trim();
const colorBrand100 : string =  getComputedStyle(document.documentElement).getPropertyValue('--color-brand-100').trim();


const bgSectionsDark : string =  getComputedStyle(document.documentElement).getPropertyValue('--color-blueGray-700').trim();
const bgBodyDark : string =  getComputedStyle(document.documentElement).getPropertyValue('--color-blueGray-800').trim();


export const customPresetColors = definePreset(Aura, {
    semantic: {
        primary: {
            50: colorBrand100,
            100: colorBrand100,
            200: colorBrand200,
            300: colorBrand300,
            400: colorBrand400,
            500: colorBrand500,
            600: colorBrand600,
            700: colorBrand700,
            800: colorBrand800,
            900: colorBrand900,
            // 950: '{zinc.950}'
        },
        colorScheme: {
            light: {
                primary: {
                    color: primaryColorLightMode,
                    // inverseColor: '#ffffff',
                    hoverColor: primaryColorLightMode,
                    activeColor:primaryColorLightMode
                },
                surface: {
                    // 950: '{zinc.950}',
                },
                highlight: {
                    background: primaryColorLightMode,
                    focusBackground: primaryColorLightMode,
                    color: '#ffffff',
                    focusColor: '#ffffff'
                }
            },
            dark: {
                primary: {
                    color: primaryColorDarkMode,
                    // inverseColor: '#ffffff',
                    hoverColor: primaryColorDarkMode,
                    activeColor: primaryColorDarkMode
                },
                surface: {
                    // 950:  '#1f1d2b', //--m-bg-1
                    900:  bgSectionsDark, // section
                    800: bgBodyDark,
                },
                highlight: {
                    background: primaryColorDarkMode,
                    // focusBackground: '{zinc.700}',
                    color: '#ffffff',
                    focusColor: '#ffffff'
                }
            }
        }
    }
});